import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.118 7.49a.14.14 0 0 1 0-.053V7.31c0-.153-.04-.307-.067-.46a.5.5 0 0 1 0-.107 5.94 5.94 0 0 0-4.033-4.4h-.054a5 5 0 0 0-.453-.12h-.12a4 4 0 0 0-.367-.053h-.16v-.173a.667.667 0 0 0-1.333 0v.04a6 6 0 0 0-.667.12 3 3 0 0 0-.413.106h-.087c-.166.054-.32.114-.48.174a5.95 5.95 0 0 0-3.486 3.746.2.2 0 0 0 0 .054 4 4 0 0 0-.127.48v.106a4 4 0 0 0-.08.5v.674a.667.667 0 0 0 .667.666h4.666v4a.667.667 0 1 1-1.333 0 .667.667 0 1 0-1.333 0 2 2 0 0 0 4 0v-4h4.666a.667.667 0 0 0 .667-.666c-.073-.174-.073-.34-.073-.507M5.45 7.33H3.504v-.073c0-.027 0-.187.054-.274.053-.086 0-.086 0-.126s.053-.214.086-.32v-.054a4.67 4.67 0 0 1 2.54-2.726 10.7 10.7 0 0 0-.733 3.573m1.333 0c.127-2.607.96-4 1.334-4 .373 0 1.193 1.393 1.333 4zm4 0a10.7 10.7 0 0 0-.733-3.573 4.67 4.67 0 0 1 2.487 2.746q.06.174.1.354a1 1 0 0 0 0 .1c0 .093.04.193.053.286.013.094 0 .047 0 .074z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })